var map = {
  "./AIGenerateButtonStar.svg": "58246",
  "./AIGenerateStar.svg": "11038",
  "./Accept.svg": "981",
  "./AccordionMinus.svg": "60755",
  "./AccordionPlus.svg": "49621",
  "./Account.svg": "26050",
  "./Accountant.svg": "23757",
  "./ActionComplete.svg": "47562",
  "./ActionItemsIcon.svg": "41222",
  "./ActionRequired.svg": "12108",
  "./ActiveBank.svg": "11725",
  "./ActiveBook.svg": "82544",
  "./ActiveCalendarCheck.svg": "73891",
  "./ActiveChatText.svg": "1764",
  "./ActiveCheckSquareOffset.svg": "97881",
  "./ActiveDataroom.svg": "95758",
  "./ActiveDeals.svg": "90396",
  "./ActiveHouse.svg": "93297",
  "./ActiveMail.svg": "1538",
  "./ActiveNextBtn.svg": "5304",
  "./ActiveNote.svg": "40575",
  "./ActivePerkCircle.svg": "77171",
  "./ActivePrevBtn.svg": "92448",
  "./ActiveTaskEdit.svg": "26912",
  "./ActiveTaskLog.svg": "64754",
  "./AddCardPlusIcon.svg": "3855",
  "./AddCheck.svg": "70786",
  "./AddClipIcon.svg": "65451",
  "./AddComment.svg": "65385",
  "./AddFolder.svg": "34450",
  "./AddIncome.svg": "81591",
  "./AddMemo.svg": "70404",
  "./AddSlack.svg": "78634",
  "./AddTeam.svg": "28733",
  "./Add_Customer_Illustration.svg": "62578",
  "./Addexpense.svg": "93890",
  "./AdminCallAccept.svg": "29122",
  "./AdminCallReject.svg": "1951",
  "./AdminCallUnresponse.svg": "30570",
  "./Agreement.svg": "35559",
  "./AllMessages.svg": "21358",
  "./AllReadyInClarify.svg": "47160",
  "./Amex.svg": "94284",
  "./AnalyseBankStatementImg.svg": "53506",
  "./AnnouncementBanner.svg": "38634",
  "./AnnualCatchup.svg": "61534",
  "./ApplyToAll.svg": "59709",
  "./Apps.svg": "25421",
  "./Archive.svg": "62489",
  "./ArchivedUser.svg": "21270",
  "./Arrow.svg": "82840",
  "./ArrowBend.svg": "73545",
  "./ArrowBendDownRight.svg": "36257",
  "./ArrowCounterClockwise.svg": "90134",
  "./ArrowDownLight.svg": "58248",
  "./ArrowDownLong.svg": "21998",
  "./ArrowElbowDownRight.svg": "95885",
  "./ArrowLineUp.svg": "54957",
  "./ArrowUpRight.svg": "30047",
  "./Arrowdown.svg": "73092",
  "./ArrowsDownUp.svg": "98052",
  "./ArrowsInOut.svg": "1218",
  "./ArrowsOut.svg": "86217",
  "./ArrowsOutLineVertical.svg": "24501",
  "./ArrowsOutSimple.svg": "91683",
  "./Assign.svg": "45638",
  "./AssignedUser.svg": "80728",
  "./AssistedIncorporationBG.svg": "74265",
  "./AuthTestimonial/MarketFeature/BooksScreen.svg": "52400",
  "./AuthTestimonial/MarketFeature/BooksScreenSmall.svg": "44501",
  "./AuthTestimonial/MarketFeature/TaxScreen.svg": "86549",
  "./AuthTestimonial/MarketFeature/TaxScreenSmall.svg": "26066",
  "./Autopay.svg": "72930",
  "./BSDummyReportTemplate.svg": "36560",
  "./BackArrow.svg": "39015",
  "./BalanceIcon.svg": "9228",
  "./BalanceSheet.svg": "4036",
  "./BalanceSheetTemplate.svg": "28810",
  "./Bank.svg": "54611",
  "./BankAccounts.svg": "29307",
  "./BankCircular.svg": "88468",
  "./BankCount.svg": "68544",
  "./BankTransfer.svg": "98614",
  "./BankTransferZeroScreen.svg": "70076",
  "./BankWarningCircle.svg": "60497",
  "./BigBooksIcon.svg": "59146",
  "./BigGreenTick.svg": "7581",
  "./BigIntragroupIcon.svg": "45163",
  "./BigMailroomIcon.svg": "30122",
  "./BigSalesTaxIcon.svg": "52057",
  "./BigTaxIcon.svg": "8239",
  "./BillCom.svg": "41597",
  "./Billing.svg": "25902",
  "./BlackArrowLeft.svg": "11258",
  "./BlackCross.svg": "6022",
  "./BlackFilledInfo.svg": "12418",
  "./BlackInfo.svg": "95534",
  "./BlackRedirect.svg": "41242",
  "./BlueHourGlass.svg": "48621",
  "./BoldClose.svg": "76152",
  "./BoldPaperclip.svg": "1872",
  "./Book.svg": "33882",
  "./BookIconTP.svg": "47333",
  "./BookKeeperIcon.svg": "6907",
  "./BookOpen.svg": "88794",
  "./BookkeepingCalendar.svg": "35901",
  "./BookkeepingSoftwareInkle.svg": "53117",
  "./BookkeepingSoftwareQuickbooks.svg": "9841",
  "./BookkeepingSoftwareWaveAccounting.svg": "24776",
  "./BookkeepingSoftwareXero.svg": "65808",
  "./BookkeepingSoftwareZoho.svg": "97414",
  "./Books.svg": "89317",
  "./BooksPreOnboarding.svg": "89579",
  "./BrexCardIcon.svg": "11015",
  "./BusinessOutsideDelawareBG.svg": "578",
  "./CPABg.svg": "11356",
  "./CalendarBackBtn.svg": "22294",
  "./CalendarBlank.svg": "77951",
  "./CalendarBlankMeeting.svg": "50870",
  "./CalendarCheck.svg": "72769",
  "./CalendarDownloadIcon.svg": "18824",
  "./CalendarFooter.svg": "84354",
  "./CalendarHeaderShadow.svg": "26496",
  "./CalendarIcon.svg": "64908",
  "./CalendarMoney.svg": "56817",
  "./CalendarShare.svg": "24964",
  "./CallBackIcon.svg": "58247",
  "./CapTableEmptyState.svg": "38351",
  "./CardAccount.svg": "59020",
  "./CardSaved.svg": "6420",
  "./CaretCircleLeft.svg": "75269",
  "./CaretCircleRight.svg": "84552",
  "./CaretDoubleDown.svg": "10233",
  "./CaretDown.svg": "95094",
  "./CaretRight.svg": "5440",
  "./CartAdd.svg": "10452",
  "./CashBalanceBackground.svg": "37976",
  "./CashFlowStatement.svg": "7159",
  "./CashMetricesBackground.svg": "96044",
  "./Celebration.svg": "71527",
  "./ChartDonut.svg": "61141",
  "./ChatGradient.svg": "54487",
  "./ChatInfoSmallRedirect.svg": "56492",
  "./ChatText.svg": "89218",
  "./ChatTicket.svg": "55127",
  "./ChatTicketIcon.svg": "40760",
  "./Chat_illustration_simple.svg": "98953",
  "./Check7004.svg": "80402",
  "./CheckBox.svg": "62382",
  "./CheckCircle.svg": "48451",
  "./CheckCircleBlack.svg": "83224",
  "./CheckCircleFilled.svg": "59839",
  "./CheckGreen.svg": "48156",
  "./CheckMark.svg": "6624",
  "./CheckSquare.svg": "9026",
  "./CheckSquareOffset.svg": "48347",
  "./CheckedIcon.svg": "30839",
  "./CheckedPerkCircle.svg": "82492",
  "./Checks.svg": "13374",
  "./ChooseFromComp.svg": "73611",
  "./CircleAdd.svg": "49754",
  "./CircleCross.svg": "72819",
  "./CircleNotch.svg": "74973",
  "./Clarify.svg": "53925",
  "./ClaudeIcon.svg": "27772",
  "./Clock.svg": "73365",
  "./ClockCounterClockwise.svg": "64091",
  "./ClockCounterClockwiseBlack.svg": "78496",
  "./ClockCounterClockwiseBlue.svg": "37579",
  "./ClockUpdate.svg": "53202",
  "./Close.svg": "88755",
  "./CloseArrow.svg": "11006",
  "./CloseChat.svg": "91733",
  "./Coin.svg": "44210",
  "./CoinVertical.svg": "66492",
  "./Comment.svg": "81284",
  "./CommentAdded.svg": "58234",
  "./Completed.svg": "38860",
  "./CompletedSummary.svg": "82356",
  "./Compliance.svg": "37408",
  "./ConnectBank.svg": "51391",
  "./Copy.svg": "90886",
  "./CopyIconBlack.svg": "51354",
  "./CopyPurple.svg": "70704",
  "./CreateBrand.svg": "50132",
  "./CreateCompany.svg": "87321",
  "./CreateCompanyBg.svg": "50151",
  "./CreditCard.svg": "59040",
  "./CreditCoin.svg": "2209",
  "./CreditInfo.svg": "95790",
  "./Cross.svg": "25259",
  "./CrossRed.svg": "69552",
  "./Currency.svg": "26320",
  "./CustomerFeedback.svg": "73084",
  "./Dashbord.svg": "24170",
  "./Dataroom.svg": "94860",
  "./Deadline.svg": "37797",
  "./DeadlineArrow.svg": "3924",
  "./DeadlineCardBlueBG.svg": "54166",
  "./DeadlineCardBlueBGBig.svg": "64380",
  "./DeadlineCardGreenBG.svg": "15105",
  "./DeadlineCardGreenBGBig.svg": "1129",
  "./DeadlineCardRedBG.svg": "57153",
  "./DeadlineCardRedBGBig.svg": "69481",
  "./Deals.svg": "90006",
  "./Decline.svg": "55553",
  "./DefaultBankLogo.svg": "70279",
  "./DefaultFeature.svg": "69806",
  "./Desktop.svg": "26859",
  "./DeviceMobileCamera.svg": "50956",
  "./DeviceTabletCamera.svg": "50842",
  "./DiamondWithBg.svg": "23554",
  "./DiamondsFlour.svg": "2358",
  "./DisabledNextBtn.svg": "98938",
  "./DisabledPrevBtn.svg": "82566",
  "./DisabledPricedTicketTag.svg": "96756",
  "./Discover.svg": "43216",
  "./DisplayPicture.svg": "80297",
  "./DoubleGreenTick.svg": "86352",
  "./Download.svg": "6597",
  "./DownloadCalendar.svg": "70623",
  "./DownloadIcon.svg": "94834",
  "./DownloadSimple.svg": "31847",
  "./Draggable.svg": "74178",
  "./DropDownPricing.svg": "22804",
  "./DropdownArrow.svg": "61581",
  "./ECLCardIcon.svg": "25170",
  "./ECLHomeCardIcon.svg": "49343",
  "./EmptyActionItem.svg": "52187",
  "./EmptyCalendar.svg": "34210",
  "./EmptyCaretRight.svg": "72761",
  "./EmptyDataSource.svg": "47111",
  "./EmptyEllipse.svg": "24269",
  "./EmptyFolder.svg": "9332",
  "./EmptyInvoices.svg": "75264",
  "./EmptyMessageBody.svg": "69069",
  "./EmptyMessageState.svg": "44840",
  "./EmptyNotification.svg": "78717",
  "./EmptyOpenedBox.svg": "38386",
  "./EmptyReports.svg": "64569",
  "./EmptyRuleEngine.svg": "4268",
  "./Entity.svg": "87119",
  "./EntityAddBtn.svg": "6119",
  "./EntityDeleteIcon.svg": "4370",
  "./EntityEditIcon.svg": "68403",
  "./EntityEditPencil.svg": "20455",
  "./Envelope.svg": "18013",
  "./EnvelopeSimple.svg": "84687",
  "./Equals.svg": "41610",
  "./ErrorIllustration.svg": "88011",
  "./Export.svg": "92371",
  "./ExternalCAInfo.svg": "85268",
  "./FAQIcon.svg": "4604",
  "./FederalRegistrationCardBG.svg": "56568",
  "./FilePdf.svg": "77655",
  "./FileSearch.svg": "76043",
  "./FilingAmendmentIllustration.svg": "53297",
  "./FilingCompleted.svg": "92393",
  "./FilingInfo.svg": "14018",
  "./FilingInprogressIcon.svg": "16685",
  "./FilingInprogressIllustration.svg": "71280",
  "./FilledClockCountDown.svg": "44066",
  "./FilledLeftCaret.svg": "73103",
  "./FilledRightCaret.svg": "5546",
  "./FinancialClosing-Home.svg": "18365",
  "./FinishPayment.svg": "37646",
  "./FloatingChat.svg": "32349",
  "./FloatingChatOpened.svg": "72129",
  "./FloatingSlack.svg": "66769",
  "./Folder.svg": "3637",
  "./Form.svg": "5451",
  "./FounderIcon.svg": "35489",
  "./FreeFilingBG.svg": "7273",
  "./FreePlanPaper.svg": "96120",
  "./FreePlatformSubscription.svg": "35217",
  "./GeneralSupport.svg": "76364",
  "./GeneratingContractors.svg": "46323",
  "./GetReminder.svg": "82997",
  "./Gift.svg": "5047",
  "./GmailI.svg": "3466",
  "./GmailIcon.svg": "90062",
  "./GmailLogo.svg": "52116",
  "./Google.svg": "94340",
  "./GoogleCalendar.svg": "23286",
  "./GrayCloseIcon.svg": "48295",
  "./GrayFilledCross.svg": "15992",
  "./GrayFilledInfo.svg": "36748",
  "./GrayGoogle.svg": "5189",
  "./GrayLinedInfo.svg": "62326",
  "./GrayPencil.svg": "55143",
  "./GrayPlusCircle.svg": "74364",
  "./GreenCheck.svg": "71070",
  "./GreenCircle.svg": "88854",
  "./GreenFlagBanner.svg": "76209",
  "./GreenInfo.svg": "23766",
  "./GreenRepeatFlagBanner.svg": "69875",
  "./GreenSolidCheck.svg": "1845",
  "./GreenTick.svg": "23829",
  "./GreenTickWithCircle.svg": "6693",
  "./GreyCaretRight.svg": "73589",
  "./GridView.svg": "61102",
  "./GustoIcon.svg": "99388",
  "./HelpCall.svg": "60128",
  "./HelpChat.svg": "38162",
  "./HelpMeetingRequest.svg": "24674",
  "./HelpWhatsapp.svg": "92066",
  "./HomeStateIcon.svg": "34800",
  "./Hourglass.svg": "41953",
  "./House.svg": "20791",
  "./Hubspot.svg": "77318",
  "./ISDummyReportTemplate.svg": "63623",
  "./IcalDownload.svg": "26694",
  "./IcalMeeting.svg": "22253",
  "./IcalShare.svg": "39019",
  "./IcalSubscribe.svg": "72210",
  "./IcalWhatsapp.svg": "70440",
  "./Imageplaceholder.svg": "21175",
  "./InProgress.svg": "70929",
  "./InProgressSummary.svg": "27559",
  "./InReview.svg": "85412",
  "./InactivePerkCircle.svg": "16010",
  "./IncomeStatement.svg": "8031",
  "./IncomeStatementTemplate.svg": "73417",
  "./IncomingCallIcon.svg": "37329",
  "./Info.svg": "80101",
  "./InfoBlack.svg": "97962",
  "./InfoBlue.svg": "94321",
  "./InfoGray.svg": "36884",
  "./Inkle-Admin.svg": "79296",
  "./Inkle-Books.svg": "5279",
  "./Inkle-Community-Logo.svg": "51678",
  "./Inkle-Interco.svg": "11237",
  "./Inkle-Legal.svg": "86394",
  "./Inkle-Mailroom.svg": "21283",
  "./Inkle-Practice-Pro.svg": "53158",
  "./Inkle-Practice.svg": "47503",
  "./Inkle-SalesTax.svg": "75188",
  "./Inkle-Tax.svg": "68882",
  "./InkleBookKeeping.svg": "7122",
  "./InkleCreditCoin.svg": "13098",
  "./InkleLogo.svg": "4163",
  "./InklePracticePromotionalCard.svg": "30293",
  "./InkleTaxAiIcon.svg": "67692",
  "./InkleWorkspace.svg": "21541",
  "./InvoiceFileText.svg": "82761",
  "./JCB.svg": "14346",
  "./JPG.svg": "56302",
  "./Laptop.svg": "58205",
  "./LaptopLg.svg": "77270",
  "./LargeEmptyStar.svg": "92765",
  "./LargeFilledStar.svg": "81526",
  "./LightMetallic.svg": "98128",
  "./Lightning.svg": "57845",
  "./LinkIcon.svg": "96258",
  "./LinkedInAdd.svg": "95792",
  "./LinkedinIcon.svg": "28420",
  "./ListView.svg": "50426",
  "./LockOnboarding.svg": "22999",
  "./Logout.svg": "95151",
  "./Mail.svg": "17516",
  "./MailRoomHomePageBG.svg": "77464",
  "./MainStreet.svg": "80763",
  "./MapPin.svg": "27862",
  "./MapPinCircular.svg": "96029",
  "./MapPinLine.svg": "2456",
  "./Mastercard.svg": "22433",
  "./Meeting.svg": "38884",
  "./Megaphone.svg": "98261",
  "./Mercury.svg": "15564",
  "./Message.svg": "81817",
  "./MessageHighlight.svg": "63986",
  "./MicrosoftTeamsLogo.svg": "71202",
  "./MinusEllipse.svg": "49799",
  "./Mis.svg": "10810",
  "./MissedCallIcon.svg": "18725",
  "./ModifyIcon.svg": "23892",
  "./NavigateArrowRight.svg": "67187",
  "./NoAsset.svg": "89384",
  "./NoBooksData.svg": "7542",
  "./NoContractor.svg": "47413",
  "./NoContractorsFound.svg": "60208",
  "./NoFixedAsset.svg": "97106",
  "./NoMail.svg": "72109",
  "./NoMis.svg": "37057",
  "./NoNotesFound.svg": "509",
  "./NoPendingActionItems.svg": "61033",
  "./NoPendingItems.svg": "42335",
  "./NoSavedCard.svg": "99487",
  "./NoService.svg": "61497",
  "./NoTaskTemplates.svg": "2656",
  "./NoTemplate.svg": "37582",
  "./NoTicketOnConversation.svg": "59522",
  "./NoTicketOnList.svg": "25275",
  "./NoTransaction.svg": "9392",
  "./NobillingMethod.svg": "9542",
  "./NonPricedTicketTag.svg": "2433",
  "./None.svg": "65487",
  "./NotApplicable.svg": "96395",
  "./NotApplicableContent.svg": "74002",
  "./NotRegisteredStateIcon.svg": "76756",
  "./Note.svg": "36961",
  "./NotePencil.svg": "17870",
  "./Notes.svg": "45840",
  "./Onboarding.svg": "73622",
  "./OnboardingAction.svg": "34744",
  "./OnboardingBackground.svg": "7862",
  "./OnboardingCelebration.svg": "77594",
  "./OnboardingCompletedBanner.svg": "87395",
  "./OnboardingOption.svg": "79485",
  "./OpenItemsHeader.svg": "24580",
  "./OptionDots.svg": "65182",
  "./OrangeInfo.svg": "81867",
  "./OtherDevice.svg": "56463",
  "./OutgoingCallIcon.svg": "34764",
  "./OutlookLogo.svg": "4787",
  "./PaymentSuccessCheck.svg": "31497",
  "./Pencil.svg": "39726",
  "./PencilSimple.svg": "21888",
  "./PendingActionEmpty.svg": "69051",
  "./PerkProvider.svg": "70198",
  "./PerkProviderBg.svg": "57719",
  "./PerksBannerBackground.svg": "68714",
  "./PerksCard.svg": "99938",
  "./PerksCardIcon.svg": "54289",
  "./PerksGiftIcon.svg": "62793",
  "./PerksHomeIcon.svg": "36186",
  "./PerksLogo.svg": "83069",
  "./PerksPopupImg.svg": "76683",
  "./PerksSparks.svg": "30254",
  "./Persona.svg": "80871",
  "./Peyaj.svg": "41736",
  "./PhoneCall.svg": "67439",
  "./PhoneCallError.svg": "88680",
  "./PhoneCross.svg": "1509",
  "./PhoneIcon.svg": "96732",
  "./PinkCross.svg": "41723",
  "./PinkHourglass.svg": "7825",
  "./PinkStar.svg": "62653",
  "./Plaid.svg": "54309",
  "./PlaidBankConnect.svg": "46963",
  "./PlaidMultipleBankLogoCircle.svg": "71474",
  "./PlaidMultipleLogos.svg": "23487",
  "./PlanCharging.svg": "39793",
  "./Platform.svg": "54300",
  "./PlusCircle.svg": "72397",
  "./PoweredByStripe.svg": "39831",
  "./PreIncorporateIcon.svg": "39477",
  "./PreincorpPackage.svg": "82279",
  "./Presentation.svg": "62353",
  "./Prevfolder.svg": "57018",
  "./PreviewImageName.svg": "40331",
  "./PricedTicketTag.svg": "52452",
  "./PrivateChat.svg": "76752",
  "./PrivateChatHeaderLock.svg": "89470",
  "./PrivateChatIcon.svg": "36843",
  "./ProcessingHourGlassIcon.svg": "27725",
  "./PublicCalendarBackground.svg": "45716",
  "./PublicCalendarTableBackground.svg": "92912",
  "./PublicCalendarTableHeader.svg": "1163",
  "./PublicChatIcon.svg": "89995",
  "./PublicWFormUploadSuccess.svg": "13041",
  "./PurpleArrow.svg": "54438",
  "./PurpleCalendar.svg": "20918",
  "./PurplePlus.svg": "9067",
  "./PurpleSparkle.svg": "51907",
  "./PurpleTick.svg": "58744",
  "./QuestionIcon.svg": "56626",
  "./QuestionIconTP.svg": "20382",
  "./QuickBooks.svg": "85672",
  "./RAndDBG.svg": "1409",
  "./RAndDTaxSavingIcon.svg": "62054",
  "./Raise.svg": "35991",
  "./RaiseHome.svg": "55986",
  "./Recurring.svg": "99878",
  "./RedCross.svg": "16478",
  "./RedFilledInfo.svg": "63450",
  "./RedFlagBanner.svg": "77758",
  "./Redirect.svg": "82001",
  "./ReferCard.svg": "93847",
  "./ReferCoins.svg": "63029",
  "./ReferLinkedIn.svg": "58955",
  "./ReferMail.svg": "74564",
  "./ReferTwitter.svg": "87746",
  "./ReferWhatsApp.svg": "84855",
  "./ReferralBanner.svg": "80452",
  "./ReferralDollarLeaf.svg": "69948",
  "./Refresh.svg": "69378",
  "./RefreshIcon.svg": "45585",
  "./RegisteredAgent.svg": "13436",
  "./RegisteredAgentCardBG.svg": "92495",
  "./RegisteredStateIcon.svg": "37411",
  "./ReminderToggleIcon.svg": "74204",
  "./RemoveCross.svg": "42535",
  "./RemoveIcon.svg": "3674",
  "./Resources.svg": "71668",
  "./RetakeQuestion.svg": "15851",
  "./RevenueMetricesBackground.svg": "25027",
  "./Reviewed.svg": "70838",
  "./ReviveSubscriptionPaymentFailed.svg": "66322",
  "./Reward.svg": "51060",
  "./RightArrowMiddle.svg": "77563",
  "./Ruti.svg": "35275",
  "./SalesCrm.svg": "67105",
  "./Search.svg": "58841",
  "./SearchIcon.svg": "582",
  "./SearchLoadingIcon.svg": "90200",
  "./Season.svg": "95026",
  "./SelfServePerkBg.svg": "59689",
  "./ServiceInprogressIllustration.svg": "84896",
  "./ShareIcon.svg": "35301",
  "./ShareNetwork.svg": "31832",
  "./SidebarMenu.svg": "83118",
  "./SignDocument.svg": "81265",
  "./SliderClose.svg": "19690",
  "./SmallBooks.svg": "34492",
  "./SmallClose.svg": "93274",
  "./SmallCross.svg": "71774",
  "./SmallEmptyOpenedBox.svg": "51333",
  "./SmallGreenTick.svg": "6660",
  "./SmallInkleBooks.svg": "5939",
  "./SmallIntragroup.svg": "55691",
  "./SmallMailroom.svg": "52394",
  "./SmallNotesIcon.svg": "62850",
  "./SmallPaperPlane.svg": "34114",
  "./SmallPlus.svg": "26098",
  "./SmallRocket.svg": "84638",
  "./SmallRocketPurple.svg": "78424",
  "./SmallSalesTax.svg": "56629",
  "./SmallSparkle.svg": "3828",
  "./SmallTax.svg": "95121",
  "./SmallWhatsappIcon.svg": "30683",
  "./SocialShareCopy.svg": "71346",
  "./SocialShareFacebook.svg": "85905",
  "./SocialShareLinkedIn.svg": "50751",
  "./SocialShareTwitter.svg": "88382",
  "./SocialShareWhatsApp.svg": "41603",
  "./SolidCross.svg": "79242",
  "./SolidRedCross.svg": "98537",
  "./SortDescending.svg": "11199",
  "./SortFunnel.svg": "7321",
  "./Sparkle.svg": "34057",
  "./SquareGreenTick.svg": "45154",
  "./SquareX.svg": "88028",
  "./Star.svg": "81421",
  "./Step 4.svg": "4415",
  "./StepCheckMark.svg": "48370",
  "./Stripe.svg": "84886",
  "./SubscribeMail.svg": "17106",
  "./SubscribeSlack.svg": "49597",
  "./SubscribeWhatsapp.svg": "97373",
  "./SubscriptionBanner.svg": "38564",
  "./SubscriptionRocket.svg": "57946",
  "./SuccessFul.svg": "69451",
  "./SuccessfuIcon.svg": "81602",
  "./SuccessfullPartyEmoji.svg": "67915",
  "./Suggested.svg": "86986",
  "./Sunset.svg": "14107",
  "./Support.svg": "74986",
  "./TPCurrentStepEllipse.svg": "64664",
  "./TPGlobe.svg": "54540",
  "./TPInfo.svg": "1961",
  "./TPInfoTPPage.svg": "56652",
  "./TPPreOnboardingBg.svg": "64974",
  "./TPStepEllipse.svg": "17779",
  "./TPxSmall.svg": "1804",
  "./TagSimple.svg": "31873",
  "./TaskChat.svg": "8092",
  "./TaskEdit.svg": "25002",
  "./TaskInProgressSocialShare.svg": "46872",
  "./TaskLog.svg": "59272",
  "./TaskSuccessfulTick.svg": "53775",
  "./TaxIcon.svg": "88951",
  "./TaxOthersFAQBG.svg": "39954",
  "./TealClock.svg": "687",
  "./TechSupport.svg": "88282",
  "./ThreeDots.svg": "7463",
  "./TickWithCircle.svg": "32778",
  "./TicketResolve.svg": "18127",
  "./TicketResolved.svg": "56577",
  "./TicketUnpaid.svg": "25246",
  "./TicketUnresolved.svg": "95972",
  "./TicketUpdated.svg": "71126",
  "./TicketsEmptyState.svg": "42550",
  "./TimerClock.svg": "59530",
  "./TinySuccess.svg": "28000",
  "./TopInsightsBackground.svg": "23545",
  "./TorusKnot.svg": "72453",
  "./TotalbalanceUI.svg": "87197",
  "./TpHomePageCard.svg": "50915",
  "./TransPaperclip.svg": "52231",
  "./TreeArrow.svg": "41692",
  "./TriangleWarning.svg": "75059",
  "./TwitterLogo.svg": "61755",
  "./UnassignMe.svg": "10741",
  "./UnionPay.svg": "93172",
  "./UnitedStatesMap.svg": "74444",
  "./UpcomingSummary.svg": "76589",
  "./UpdateArrow.svg": "99869",
  "./Upgrade.svg": "65203",
  "./Upload.svg": "40018",
  "./UploadAdd.svg": "26943",
  "./UploadCSV.svg": "26402",
  "./UploadFile.svg": "96848",
  "./UploadFilePublic.svg": "49883",
  "./UploadIcon.svg": "59137",
  "./UploadSimple.svg": "59340",
  "./Uploaded.svg": "96965",
  "./User.svg": "2048",
  "./UserList.svg": "16040",
  "./UserListCircular.svg": "26375",
  "./UserPlus.svg": "32000",
  "./UserSwitch.svg": "39084",
  "./UsersThree.svg": "77701",
  "./VerificationIllustration.svg": "9174",
  "./Verify.svg": "70346",
  "./Verifying.svg": "55230",
  "./VerticalLine.svg": "31925",
  "./VerticalSeparator.svg": "13820",
  "./VideoCamera.svg": "75239",
  "./VideoCameraIcon.svg": "99816",
  "./Visa.svg": "11666",
  "./VisitLink.svg": "77954",
  "./Warning.svg": "78463",
  "./WarningCircle.svg": "7779",
  "./WhatsNew.svg": "25368",
  "./WhatsappIcon.svg": "68848",
  "./WhiteArrowLeft.svg": "83304",
  "./WhiteCheck.svg": "42340",
  "./WhiteClose.svg": "40240",
  "./WhiteCloseIcon.svg": "17547",
  "./WhiteDown.svg": "27352",
  "./WhiteInkleLogo.svg": "30636",
  "./WhiteUp.svg": "30187",
  "./WideScreen.svg": "93848",
  "./WithInkle.svg": "59754",
  "./X.svg": "7099",
  "./XCircle.svg": "26143",
  "./XCross.svg": "17141",
  "./YearlyAdvanceTaskComplete.svg": "15961",
  "./ZohoBooks.svg": "10535",
  "./ZohoExport.svg": "33645",
  "./accountantIcon.svg": "46538",
  "./activeDrive.svg": "48205",
  "./cardIcon.svg": "47040",
  "./check.svg": "6751",
  "./dash.svg": "4493",
  "./filterIcon.svg": "50088",
  "./founderPersonaIcon.svg": "55689",
  "./inkleFavIcon.svg": "10650",
  "./interco.svg": "42911",
  "./linkpaste.svg": "88934",
  "./mailroomPlan.svg": "70736",
  "./microsoftLogoBlue.svg": "55058",
  "./newSlack.svg": "29351",
  "./notUploaded.svg": "85084",
  "./partnerIcon.svg": "71509",
  "./previewInvoice.svg": "87552",
  "./settings.svg": "10730",
  "./transferImage.svg": "98351",
  "./updateSlack.svg": "40374",
  "./uploadCloud.svg": "61697",
  "./uploadFolder.svg": "22850",
  "./uploadedFileIcon.svg": "388"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function webpackContextKeys() {
  return Object.keys(map);
};
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 81563;
